import { useCallback, useContext } from 'react'

import { MaskedInput } from '~/components/TextInput'
import { setCorporalEvaluationImageIndex } from '~/modules/corporalEvaluation/services'
import { patchEvaluationAtom } from '~/modules/evalutation/services'
import { studentEvaluationDemoContext } from '~/pages/authenticated/personalTrainer/studentEvaluationDemo'

export const Direto: React.FC = () => {
  const { data } = useContext(studentEvaluationDemoContext)

  const handleFocus = useCallback(() => {
    setCorporalEvaluationImageIndex(0)
  }, [])

  return (
    <div>
      <MaskedInput
        value={data?.direct || 0}
        mode='horizontal'
        label='Percentual de Gordura'
        placeholder='0,0'
        mask='float'
        inputMode='numeric'
        onFocus={handleFocus}
        onChange={(v) => {
          patchEvaluationAtom({
            direct: v,
          })
        }}
      />
    </div>
  )
}
